import * as React from 'react'
import * as SideMenu from 'components/side-menu'
import {
  HouseSimple,
  DoorOpen,
  CreditCard,
  Globe,
  ApproximateEquals,
} from '@phosphor-icons/react'
import { store } from 'store/index'
import { Warning } from 'src/design-system/icons/Warning'
import { useIsActivePath } from '../../../utils/use-is-active'
import { IntegrationsAccordion } from './integrations-accordion'
import { Org } from 'src/store/modules/orgs'

type OrgSectionProps = {
  showSsoLink: boolean
}

export const OrgSection = (props: OrgSectionProps) => {
  const { showSsoLink } = props

  const { isActive } = useIsActivePath()
  const orgSlug = store.currentUser?.org?.slug
  const orgName = store.currentUser?.org?.name
  const positionMapping = store.currentUser?.org?.enablePositionMapping
  const hasIssues = store.currentUser?.org?.hasIssues
  const enableHealthAudit = store.currentUser?.org?.enableHealthAudit
  const isAdmin = store.currentUser?.isAdmin

  const sectionItems = [
    {
      title: (
        <>
          General
          {hasIssues && enableHealthAudit && isAdmin && <Warning />}
        </>
      ),
      href: `/orgs/${orgSlug}/edit`,
      icon: HouseSimple,
    },
    {
      title: 'User Permissions',
      href: `/orgs/${orgSlug}/preferences`,
      icon: DoorOpen,
    },
    {
      title: 'Billing',
      href: `/orgs/${orgSlug}/billing`,
      icon: CreditCard,
    },
    {
      title: (
        <>
          Organisation Home
          {hasIssues && enableHealthAudit && isAdmin && <Warning />}
        </>
      ),
      href: `/orgs/${orgSlug}/organisation-home`,
      icon: Globe,
    },
    ...(positionMapping
      ? [
          {
            title: 'Position Aliases',
            href: `/orgs/${orgSlug}/position-aliases`,
            icon: ApproximateEquals,
          },
        ]
      : []),
  ]

  return (
    <SideMenu.MenuSection>
      <SideMenu.MenuSectionTitle>{orgName}</SideMenu.MenuSectionTitle>
      {sectionItems.map((item) => (
        <SideMenu.LinkItem
          key={item.href}
          href={item.href}
          active={isActive(item.href)}
          icon={item.icon}
        >
          {item.title}
        </SideMenu.LinkItem>
      ))}
      <IntegrationsAccordion showSsoLink={showSsoLink} />
    </SideMenu.MenuSection>
  )
}
